"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
require("./pagination.css");
var Pagination = function (props) {
    // Calculating max number of pages
    var noOfPages = Math.ceil(props.totalrows / props.rowsperpage);
    // Creating an array with length equal to no.of pages
    var pagesArr = __spreadArray([], new Array(noOfPages), true);
    // State variable to hold the current page. This value is
    // passed to the callback provided by the parent
    var _a = (0, react_1.useState)(1), currentPage = _a[0], setCurrentPage = _a[1];
    // Navigation arrows enable/disable state
    var _b = (0, react_1.useState)(false), canGoBack = _b[0], setCanGoBack = _b[1];
    var _c = (0, react_1.useState)(true), canGoNext = _c[0], setCanGoNext = _c[1];
    // Onclick handlers for the butons
    var onNextPage = function () { return setCurrentPage(currentPage + 1); };
    var onPrevPage = function () { return setCurrentPage(currentPage - 1); };
    var onPageSelect = function (pageNo) {
        setCurrentPage(pageNo);
    };
    // Disable previous and next buttons in the first and last page
    // respectively
    (0, react_1.useEffect)(function () {
        if (noOfPages === currentPage) {
            setCanGoNext(false);
        }
        else {
            setCanGoNext(true);
        }
        if (currentPage === 1) {
            setCanGoBack(false);
        }
        else {
            setCanGoBack(true);
        }
    }, [noOfPages, currentPage]);
    // To set the starting index of the page
    (0, react_1.useEffect)(function () {
        var skipFactor = (currentPage - 1) * props.rowsPerPage;
        // Some APIs require skip for pagination. If needed use that instead
        // pageChangeHandler(skipFactor);
        props.pagechangehandler(currentPage);
    }, [currentPage]);
    return (React.createElement(React.Fragment, null, noOfPages > 1 ? (React.createElement("div", { id: "pagination" },
        React.createElement("div", { className: "pageButtons" },
            React.createElement("button", { className: "pageBtn", onClick: onPrevPage, disabled: !canGoBack }, "\u2039"),
            pagesArr.map(function (num, index) { return (React.createElement("button", { className: (index + 1) === currentPage ? "activeBtn" : "pageBtn", onClick: function () { return onPageSelect(index + 1); } }, index + 1)); }),
            React.createElement("button", { className: "pageBtn", onClick: onNextPage, disabled: !canGoNext }, "\u203A")))) : null));
};
exports.default = Pagination;
//# sourceMappingURL=pagination.js.map